import { RULES_VERSION, rulesFor } from '@words-happen/board-rules-engine-client';
import type { TileData } from '../board/board-types';

const rules = rulesFor(RULES_VERSION);

/**
 * A rack's room is counted in characters, not in tiles: a two-character tile takes two of the eight
 * places a rack has, the same two cells it will take on the board. These are the three questions that
 * asks — how much room a tile needs, how much a set of them needs, and how many of them fit.
 */

/** Rack places a tile takes — one per character of its face. */
export const tileSpan = (tile: TileData): number => rules.tileSpan(tile.letter);

/** Places `tiles` take together. */
export const rackSpan = (tiles: TileData[]): number => tiles.reduce((total, tile) => total + tileSpan(tile), 0);

/**
 * The leading run of `tiles` that fits in `capacity` places. Stops at the first tile too wide for
 * what is left rather than skipping it, so the tiles kept are always a prefix of rack order — which
 * is what lets the rack render them in their slots and the ghosts after them.
 */
export function tilesWithin(tiles: TileData[], capacity: number): TileData[] {
  const within: TileData[] = [];
  let room = capacity;
  for (const tile of tiles) {
    const span = tileSpan(tile);
    if (span > room) break;
    within.push(tile);
    room -= span;
  }
  return within;
}
